import React from 'react'
import { Helmet } from 'react-helmet-async'

const SEOHead = ({ 
  title = 'Shri V.D. Patel Madhyamik School - Sardar Patel Educational Trust | Best School in Mandavad, Gujarat',
  description = 'Official website of Shri V.D. Patel Madhyamik School operated by Sardar Patel Educational Trust - Quality education from Primary to Secondary levels in Mandavad, Visavadar, Junagadh, Gujarat. Admission open for 2025-26. Excellence in academics, sports, and character building.',
  keywords = 'Shri V.D. Patel Madhyamik School, VD Patel School, Sardar Patel Educational Trust, SPET Mandavad, school in Mandavad, school in Visavadar, school in Junagadh, Gujarat school, best school near Visavadar, primary education Gujarat, secondary education Gujarat, CBSE school, admission 2025, quality education, English medium school, Gujarati medium school, character education, sports activities, school admission Gujarat',
  canonical,
  image = 'https://vdpms.in/logo.jpeg',
  type = 'website',
  noIndex = false,
  structuredData = [],
  alternateLinks = [],
  children 
}) => {
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : 'https://vdpms.in')
  const siteName = 'Shri V.D. Patel Madhyamik School'
  const fullImageUrl = image.startsWith('http') ? image : `https://vdpms.in${image}`
  const robotsDefault = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
  const robotsContent = noIndex ? 'noindex, nofollow' : robotsDefault
  const crawlerContent = noIndex ? 'noindex, nofollow' : 'index, follow'
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Shri V.D. Patel Madhyamik School - Sardar Patel Educational Trust" />
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={crawlerContent} />
      <meta name="bingbot" content={crawlerContent} />
      <meta name="language" content="English, Gujarati, Hindi" />
      <meta name="revisit-after" content="7 days" />
      <meta name="rating" content="General" />
      <meta name="distribution" content="Global" />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="IN-GJ" />
      <meta name="geo.placename" content="Mandavad, Visavadar, Junagadh, Gujarat" />
      <meta name="geo.position" content="21.3493;70.7512" />
      <meta name="ICBM" content="21.3493, 70.7512" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      {alternateLinks.map((link) => (
        link?.href && link?.hrefLang ? (
          <link rel="alternate" href={link.href} hrefLang={link.hrefLang} key={`${link.href}-${link.hrefLang}`} />
        ) : null
      ))}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:secure_url" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Shri V.D. Patel Madhyamik School Logo" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:locale:alternate" content="gu_IN" />
      <meta property="og:locale:alternate" content="hi_IN" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content="Shri V.D. Patel Madhyamik School Logo" />
      <meta name="twitter:site" content="@mandavadsankul" />
      <meta name="twitter:creator" content="@mandavadsankul" />
      
      {/* Favicon */}
      <link rel="icon" type="image/webp" href="/logo.jpeg" />
      <link rel="apple-touch-icon" href="/logo.jpeg" />
      
      {/* Additional meta tags */}
      <meta name="theme-color" content="#92278F" />
      <meta name="msapplication-TileColor" content="#92278F" />
      <meta name="msapplication-config" content="/browserconfig.xml" />
      
      {/* Viewport for mobile optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      
      {/* Preconnect for performance */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {structuredData.map((schema, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(schema)}
        </script>
      ))}

      {children}
    </Helmet>
  )
}

export default SEOHead